import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "@/context/AuthContext";

export const Navbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const auth = useAuth();
  const accountLabel = auth && auth.isAuthed ? "Mon compte" : "Retrouver mon résultat";

  const goAnchor = (id) => {
    setOpen(false);
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="navbar" aria-label="Navigation principale">
      <div className="container navbar-inner">
        <Logo onClick={() => navigate("/")} />
        <div className="nav-links">
          <button onClick={() => goAnchor("comment")} data-testid="nav-comment">Comment ça marche</button>
          <button onClick={() => goAnchor("questions")} data-testid="nav-questions">Questions</button>
          <button onClick={() => navigate("/tarifs")} data-testid="nav-tarifs">Tarifs</button>
          {auth && auth.isAuthed && auth.user && (
            <button onClick={() => navigate("/coach")} data-testid="nav-coach">Coach IA</button>
          )}
          {auth && auth.isAuthed && auth.user && (
            <button onClick={() => navigate("/credits")} data-testid="nav-credits" className="credits-pill"><b>{auth.user.credits_balance || 0}</b> crédits</button>
          )}
          <button onClick={() => navigate("/retrouver")} data-testid="nav-retrouver">{accountLabel}</button>
          <button onClick={() => navigate("/quiz")} data-testid="nav-cta" className="btn-primary btn-small">Créer mon business <span aria-hidden="true">→</span></button>
        </div>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} aria-expanded={open} aria-controls="mobile-navigation">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="mobile-menu" id="mobile-navigation" data-testid="mobile-navigation">
          <button onClick={() => goAnchor("comment")} data-testid="mobile-nav-comment">Comment ça marche</button>
          <button onClick={() => goAnchor("questions")} data-testid="mobile-nav-questions">Questions</button>
          <button onClick={() => { setOpen(false); navigate("/retrouver"); }} data-testid="mobile-nav-retrouver">{accountLabel}</button>
          {auth && auth.isAuthed && (
            <button onClick={() => { setOpen(false); navigate("/coach"); }} data-testid="mobile-nav-coach">Coach IA</button>
          )}
          <button onClick={() => { setOpen(false); navigate("/quiz"); }} className="btn-primary" data-testid="mobile-nav-cta">Créer mon business →</button>
        </div>
      )}
    </nav>
  );
};
